export default __webpack_public_path__ + "static/media/coffee-cup.f498a306.svg";